import { getContextUrl, API_URL_PREFIX, AUTH_URL_PREFIX } from "../../helpers/baseUrlHelper";

export const BASE_URL = `${process.env.BASE_URL}`;
export const LOCAL_LOGIN_URL = `${process.env.LOGIN_URL}`;

export const ASSETS_PATH = `${process.env.ASSETS_PATH}`;

export const ROOT_URL = getContextUrl(API_URL_PREFIX, BASE_URL);
export const NEW_LOGIN_URL = getContextUrl(AUTH_URL_PREFIX, LOCAL_LOGIN_URL);

export const GET_USER_API = 'en/account/user';

export const UPDATE_USER_ONBOARDING_API = 'en/account/onboarding';

export const GET_LIMITS_API = 'dashboard/limits/status';

export const GET_CONFIGURATIONS = 'account/configurations';

export const GET_BRANDING = 'dashboard/branding';

export const GET_BILLING_INFO_PATH = 'en/billing/info';

export const CANCEL_EMAIL_UPDATE_PATH = 'update/email/cancel';

export const RESEND_ACTIVATION_EMAIL_PATH = 'en/register/activate/resend';

export const CHANGE_DASHBOARD_LANGUAGE = 'logged_user/dashboard_language_code';

export const UPDATE_TOUR_STATUS = 'signacademy/student/user_lane';